import * as z from 'zod';
import { FIRST_PAGE, PAGE_SIZE_OPTIONS } from '@noor/config';

export const RBAC_AUDIT_LIMIT = 50;
export const rbacSearchSchema = z.object({
  page: z.coerce.number().int().positive().catch(FIRST_PAGE),
  pageSize: z.coerce
    .number()
    .refine((value) => PAGE_SIZE_OPTIONS.some((size) => size === value))
    .catch(10),
  tab: z.enum(['matrix', 'routes', 'features', 'grants', 'audit']).catch('routes'),
  q: z.string().optional(),
  vertical: z.string().optional(),
  user_type: z.enum(['user', 'merchant']).optional().catch(undefined),
  include_deprecated: z.boolean().catch(false),
  route_id: z.string().optional(),
  subject_id: z.coerce.number().int().positive().optional().catch(undefined),
  user_id: z.string().optional(),
  before_id: z.coerce.number().int().positive().optional().catch(undefined),
});
export const routeFiltersSchema = rbacSearchSchema.pick({
  q: true,
  vertical: true,
  include_deprecated: true,
});
export const grantFiltersSchema = rbacSearchSchema.pick({
  route_id: true,
  subject_id: true,
  user_id: true,
});
export type RbacSearch = z.infer<typeof rbacSearchSchema>;
export type RouteFilters = z.infer<typeof routeFiltersSchema>;
export type GrantFilters = z.infer<typeof grantFiltersSchema>;

export const rbacPaginationSchema = rbacSearchSchema.pick({ page: true, pageSize: true });
export type RbacPagination = z.infer<typeof rbacPaginationSchema>;
export const featureFiltersSchema = rbacSearchSchema.pick({ q: true, user_type: true });
export type FeatureFilters = z.infer<typeof featureFiltersSchema>;
